import React from 'react';

interface DisclosureSectionProps {
  id: string;
  title: string;
  summary: string;
  open: boolean;
  hasError?: boolean;
  onOpenChange(open: boolean): void;
  children: React.ReactNode;
}

const DisclosureSection: React.FC<DisclosureSectionProps> = ({
  id,
  title,
  summary,
  open,
  hasError = false,
  onOpenChange,
  children,
}) => {
  const contentId = `${id}-content`;

  return (
    <div
      className={`overflow-hidden rounded-md border ${
        hasError
          ? 'border-red-500 dark:border-red-400'
          : 'border-gray-300 dark:border-gray-600'
      }`}
    >
      <button
        type="button"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => onOpenChange(!open)}
        className="flex w-full items-center gap-3 bg-white px-3 py-2 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-club-blue-500 dark:bg-gray-800"
      >
        <span
          className={`text-sm font-medium ${
            hasError
              ? 'text-red-600 dark:text-red-400'
              : 'text-gray-700 dark:text-gray-200'
          }`}
        >
          {title}
        </span>
        <span className="min-w-0 flex-1 truncate text-sm text-gray-500 dark:text-gray-400">
          {summary}
        </span>
        <svg
          aria-hidden="true"
          viewBox="0 0 20 20"
          fill="currentColor"
          className={`h-5 w-5 shrink-0 text-gray-400 transition-transform ${
            open ? 'rotate-180' : ''
          }`}
        >
          <path
            fillRule="evenodd"
            d="M5.22 7.22a.75.75 0 0 1 1.06 0L10 10.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 8.28a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {open && (
        <div
          id={contentId}
          className="border-t border-gray-200 bg-white px-3 py-3 dark:border-gray-700 dark:bg-gray-900"
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default DisclosureSection;
